import Vue from 'vue';

import ButtonVue from './Button.vue';

export default function buttonComponent(_Vue: typeof Vue) {
  _Vue.component('AppButton', ButtonVue);
}
